import { BaseEntity } from '@bndes/bndes-angular-utils';

export class Assinatura extends BaseEntity {
    id: number;    
    papel: string;
    alcada: string;   
    ativo: boolean;
    assinado: boolean;
    tipoSituacaoAssinatura: any;

    hashAssinatura?: string;
    ipOrigem?: string;
    justificativa?: string;
    dataAssinatura?: Date;
    dataEnvio?: Date;
    dataLeitura?: Date;

    nomeCompleto: string;
    funcao?: string;
    lotacao?: string;
    idUnidadeOrganizacional?: string;
    emailAssinante?: string;

    static criarVazio(): Assinatura
    {
        return Object.assign(new Assinatura(), {
            id: null,
            papel: null,
            alcada: null,
            documentoTramite: null,
            tipoAssinatura: null,
            situacaoAssinatura: null,
            hashAssinatura: null,
            ipOrigem: null,
            justificativa: null,
            dataAssinatura: null,
            dataEnvio: null,
            dataLeitura: null,
            nomeCompleto: null,
            funcao: null,
            login: null,
            cpf: null,
            lotacao: null,
            idUnidadeOrganizacional: null,
            tipoAssinante: null,
            emailAssinante: null
        });
    }
}